import { DataScope } from './../data-scope';
import { Page } from "../page";
import { OrderQueryScopeEnum } from '../../enums/order-query-scope.enum';
import { SortOrder } from '../../interface/sort-order';

export class QueryMergeKeyRequest extends Page {

  mergeKeys: Array<String> | null;
  doNos: Array<String> | null;
  dataScopes: Array<DataScope> | null;
  consigneeKeys: Array<String> | null;
  createUser: string | null;
  createDtStart: any | null;
  createDtEnd: any | null;
  timeZone: String | null;
  userEmail: string | null;
  confirmStatus: Array<String> | null;
  orderQueryScope: OrderQueryScopeEnum;
  sortOrder: SortOrder | null;

  constructor() {
    super();
    this.mergeKeys = [];
    this.doNos = [];
    this.dataScopes = [];
    this.consigneeKeys = [];
    this.createUser = null;
    this.createDtStart = null;
    this.createDtEnd = null;
    this.timeZone = null;
    this.userEmail = null;
    this.confirmStatus = [];
    this.orderQueryScope = OrderQueryScopeEnum.personal;
    this.sortOrder = null;
  }
}
